var map = {
	"./Badschrank_1_lowres.jpg": 5302,
	"./Badschrank_2_lowres.jpg": 6438,
	"./Badschrank_3_lowres.jpg": 721,
	"./Bett_1_lowres.jpg": 1500,
	"./Bett_2_lowres.jpg": 5643,
	"./Buffet_1_lowres.jpg": 7380,
	"./Buffet_2_lowres.jpg": 4274,
	"./Couchtisch_1_lowres.jpg": 3397,
	"./Couchtisch_2_lowres.jpg": 1388,
	"./Matthias-2_lowres.jpg": 8094,
	"./Matthias_1_lowres.jpg": 7225,
	"./Matthias_2_lowres.jpg": 7276,
	"./Matthias_3_lowres.jpg": 76,
	"./Matthias_about_lowres.jpg": 4068,
	"./Meister_1_lowres.jpg": 5913,
	"./Meister_2_lowres.jpg": 4288,
	"./Mika_about_lowres.jpg": 7987,
	"./Nachttisch_1_lowres.jpg": 9379,
	"./Nachttisch_2_lowres.jpg": 6918,
	"./Sideboard_1_lowres.jpg": 697,
	"./Sideboard_2_lowres.jpg": 2420,
	"./Sideboard_3_lowres.jpg": 9802,
	"./Tisch_1_lowres.jpg": 5646,
	"./Tisch_2_lowres.jpg": 4837,
	"./Tisch_3_lowres.jpg": 7316,
	"./Tisch_4_lowres.jpg": 5192,
	"./Tisch_5_lowres.jpg": 9213,
	"./Tisch_6_lowres.jpg": 189,
	"./group_2_lowres.jpg": 8482,
	"./home_both_lowres.jpg": 6631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2298;